import { render, staticRenderFns } from "./WatchlistItem.vue?vue&type=template&id=04ee3b8a&"
import script from "./WatchlistItem.vue?vue&type=script&lang=js&"
export * from "./WatchlistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ee3b8a')) {
      api.createRecord('04ee3b8a', component.options)
    } else {
      api.reload('04ee3b8a', component.options)
    }
    module.hot.accept("./WatchlistItem.vue?vue&type=template&id=04ee3b8a&", function () {
      api.rerender('04ee3b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/watchlist/WatchlistItem.vue"
export default component.exports